import {
  getModule,
  Module,
  Mutation,
  VuexModule,
} from "vuex-module-decorators";
import { temporaryStore } from "@/store";
import { assignmentApi } from "@/api/ilect-openapi-configuration";
import router from "@/router";

// Is this interface needed?
export interface BreadcrumbState {
  courseName: string;
  assignmentName: string;
  // Computed from assignment name and username
  submissionName: string;
  forumTitle: string;
  supportTitle: string;
  videoTitle: string;
}

// Used to store data required for breadcrumbs.
@Module({
  dynamic: true,
  store: temporaryStore,
  namespaced: true,
  name: "breadcrumb",
  preserveState: false,
})
export default class Breadcrumb extends VuexModule implements BreadcrumbState {
  public courseName = "";
  public assignmentName = "";
  public quizName = "";
  public submissionName = "";
  public forumTitle = "";
  public supportTitle = "";
  public videoTitle = "";

  @Mutation
  public setCourseName(courseName: string) {
    this.courseName = courseName;
  }

  @Mutation
  public setAssignmentName(assignmentName: string) {
    this.assignmentName = assignmentName;
  }

  @Mutation
  public setQuizName(quizName: string) {
    this.quizName = quizName;
  }

  @Mutation
  public setSubmissionName(submissionName: string) {
    this.submissionName = submissionName;
  }

  @Mutation
  public setForumTitle(forumTitle: string) {
    this.forumTitle = forumTitle;
  }

  @Mutation
  public setSupportTitle(supportTitle: string) {
    this.supportTitle = supportTitle;
  }

  @Mutation
  public setVideoTitle(videoTitle: string) {
    this.videoTitle = videoTitle;
  }

  public get getCourseName() {
    return () => {
      return this.courseName;
    };
  }

  public get getAssignmentName() {
    return () => {
      if (!this.assignmentName) {
        const route = router.currentRoute.value;

        if (!("assignment_id" in route.params)) {
          return "";
        }

        assignmentApi
          .assignmentRetrieve(route.params.assignment_id as string)
          .then((res) => {
            BreadcrumbModule.setAssignmentName(res.data.title);
            return this.assignmentName;
          });
      }
      return this.assignmentName;
    };
  }

  public get getVideoTitle() {
    return () => {
      return this.videoTitle;
    };
  }
}

export const BreadcrumbModule = getModule(Breadcrumb);
